export const LANDING_URL = 'https://www.bicevida.cl/seguro-de-vida-personal/seguro-de-accidentes/seguro-decesos'
